import { Box, Loader, Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import { OverviewSection, OverviewSectionSizes, OverviewSectionSkins } from '@wix/rules-panel-ui';
import React from 'react';
import { BiCtaNames } from '../../bi/types';
import { usePanelStateAtom } from '../../hooks/rules-state/use-panel-state-atom';
import { useBiLogger } from '../../hooks/use-bi-logger';
import { resolveGroupAnalysisState } from '../../utils/resolve-group-analysis-state';
import { DrillInScreenHeader } from '../fixers/alt-image-fixer/drill-in/drill-in-header/drill-in-screen-header';
import { useVerticalDrillInScreen } from './use-vertical-drill-in-screen';
export const VerticalsDrillInTopSection = () => {
  var _getGroupData;
  const {
    navigateBackToMainPanel,
    closePanel,
    screenTitle,
    itemType,
    totalNumOfIssues,
    pageId
  } = useVerticalDrillInScreen();
  const biLogger = useBiLogger();
  const {
    t
  } = useTranslation();
  const {
    getGroupData
  } = usePanelStateAtom();
  const analysisState = (_getGroupData = getGroupData(pageId ?? '')) == null ? void 0 : _getGroupData.analysisState;
  const isScanning = analysisState ? resolveGroupAnalysisState(analysisState).isAnalyzing : false;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    width: "100%"
  }, /*#__PURE__*/React.createElement(DrillInScreenHeader, {
    showDivider: false,
    title: screenTitle,
    onClickBack: () => {
      navigateBackToMainPanel();
      biLogger.ctaClick({
        ctaName: BiCtaNames.BackFromCrossPage
      });
    },
    onClickClose: closePanel
  }), /*#__PURE__*/React.createElement(Box, {
    padding: "0 20px 24px 20px"
  }, /*#__PURE__*/React.createElement(OverviewSection, {
    description: /*#__PURE__*/React.createElement(Text, {
      size: "tiny",
      weight: "normal"
    }, t(`accessibility-wizard.verticals-drill-in.top-section.overview-section.description.${itemType}`, {
      numberOfIssues: totalNumOfIssues
    })),
    detectedIssues: isScanning ? /*#__PURE__*/React.createElement(Loader, {
      size: "tiny"
    }) : totalNumOfIssues,
    size: OverviewSectionSizes.small,
    skin: OverviewSectionSkins.warning
  })));
};
//# sourceMappingURL=verticals-drill-in-top-section.js.map